import { formatSpace } from './space'

export const radii = {
  md: formatSpace(3),
}
